import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicTableConfig } from '@sharedComponents/table-dynamic/interfaces';
import { PrimengModule } from '@SharedModules/primeng.module';

@Component({
  selector: 'table-skeleton',
  standalone: true,
  imports: [CommonModule, PrimengModule],
  templateUrl: './table-skeleton.component.html',
  styleUrl: './table-skeleton.component.scss'
})
export class TableSkeletonComponent {
  config = input<DynamicTableConfig<any>>();
}
